// extracted by mini-css-extract-plugin
export default {"container":"ViewApplication_container__r5oZf"};